const intelligence = {
  slug: 'f/intelligence',
  getLatestQir: () => `${intelligence.slug}/reports/quarterly/latest`,
  purchaseQirSingle: id =>
    `${intelligence.slug}/reports/quarterly/${id}/purchase`
}

export default intelligence
